import {useNavigationStore} from '@/stores/navigation';

/**
 * exeptions router names, like /promotions/starting-business = promotions-starting-business
 */
const EXCEPTIONS = [
    'agreement',
    'business-bank-guarantees',
    'certificate-of-safety',
    'dbo',
    'deposit-insurance',
    'financial-commissioner',
    'presentation-information',
    'search',
    'support-measures',
    'unsubscribe',
    'business-acquiring-instructionsqrlink',
    'business-bank-agreement-form',
    'business-bank-agreement-sign-bki-form',
    'documents-slug',
    'documents-dkbo',
    'starting-business',
    'promotions-starting-business',
];

export default function(ctx) {
    const navigationStore = useNavigationStore();
    navigationStore.hideBreadcrumbs = EXCEPTIONS.includes(ctx.route.name);

    if (ctx.from?.path && ctx.from?.path !== ctx.route.path) {
        navigationStore.getBreadcrumbs({route: ctx.route});
    }
};
